export class AppMessage {
    appMessageId: number;
    langId: number;
    termsText: string;
    gdprText: string;
    termsHeader: string;
    gdprHeader: string;
    name: string;
    lastName: string;
    country: string;
    male: string;
    female: string;
    age: string;
    email: string;
    source: string;
    signatureError: string;
    signatureHeader: string;
}
